import { notification } from 'antd'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { acceptTerms, getTermsCheck, TermsCheck } from './termsApi'

const TERMS_CHECK_KEY = ['terms', 'check']

export const useTermsCheck = (enabled: boolean) => {
  return useQuery({
    queryKey: TERMS_CHECK_KEY,
    queryFn: getTermsCheck,
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}

export const useAcceptTermsMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: acceptTerms,
    onSuccess: () => {
      queryClient.setQueryData<TermsCheck | undefined>(TERMS_CHECK_KEY, (existing) => {
        if (!existing) {
          return existing
        }
        return { ...existing, needsAcceptance: false }
      })
    },
    onError: () => {
      notification.error({ message: 'There was an error recording your acceptance. Please try again later.' })
    }
  })
}
